import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { CommonHelper } from '../../../../../utilities/common.helper';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';

@Component({
	selector: 'kt-student-details',
	templateUrl: './student-details.component.html',
	styleUrls: ['./student-details.component.css']
})
export class StudentDetailsComponent implements OnInit {
	public stuData;
	public formType: any = null
	public focalPersonTypes = HEC_CONSTANTS.FOCAL_PERSONS
	public modalData: any = null
	public applicationNumber: number = null
	public pageState: string = ''
	public processAcronym: string = 'COURSERA'
	public documentList: Array<any> = []
	public applicantName: any;
	constructor(private dialogRef: MatDialogRef<StudentDetailsComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		private sharedService: SharedService,
		private loaderService: LoaderService,) { }

	ngOnInit() {
		console.log(this.data);
		if (this.data) {
			this.formType = this.data.formType
			console.log(this.formType);
			this.pageState = this.data.pageState
			this.modalData = this.data.data
			console.log("modalData below")
			console.log(this.modalData)
			this.applicantName = this.modalData.name
			console.log(this.applicantName);
			this.applicationNumber = this.data.data.id
			this.getProfileDetails();
			console.log(this.formType);
			if (this.formType == this.focalPersonTypes.HEC_APPLICANT) {
				this.getCurrentDocumentList('COURSERA')
				if (this.applicationNumber <= 50500) {
					this.getCurrentDocumentList('CMNPROF')

				}
			}
			if (this.formType == this.focalPersonTypes.UNIVERSITY || this.formType == this.focalPersonTypes.HEC_UNIVERSITY) {
				this.getCurrentDocumentList('COURSERA')
				if (this.applicationNumber <= 50500) {
					this.getCurrentDocumentList('CMNPROF')

				}
			}
		}
	}

	onClose(): void {
		this.dialogRef.close();
	}

	private getCurrentDocumentList(acronym): void {
		let payload = {
			data: {
				applicationId: +this.applicationNumber,
				processAcronym: acronym,
			},
		};
		this.getDocumentsService(payload);
	}

	public downloadDocument(document): void {
		console.log(document);
		if (document && document.title) {
			let payload = {
				data: {
					acronym: this.processAcronym,
					documentId: document.documentId
				},
			};
			this.downloadAttachmentService(payload, document)
		} else {
			this.sharedService.showError(
				'Document Not Found',
				'OK',
				'error-snackbar'
			);
		}

	}

	private async getDocumentsService(payload) {
		// this.loaderService.setValue(true)
		try {
			const res: any = await this.sharedService
				.getDocumentService(payload)
				.toPromise();
			// this.loaderService.setValue(false)
			if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
				this.documentList = res.data


			} else if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.NO_DATA_FOUND) {

			} else {

			}
		} catch (error) {
			// this.loaderService.setValue(false)
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(
					HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG,
					'OK',
					'error-snackbar'
				);
			} else {
			}
		}
	}


	private  getProfileDetails() {
		this.sharedService.getProfileDetails(this.applicationNumber).subscribe(
			(res: any) => {
			  if (res && res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
				this.modalData = res.data
				this.modalData.name = this.data.data.applicantName
				return;
			  }
			  this.sharedService.showError(
				HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG,
				'OK',
				'error-snackbar'
			);
			},
			(err) => {
				console.log(err);
							 
				this.sharedService.showError(err.error, 'OK', 'error-snackbar');
			})
		
	}

	private async downloadAttachmentService(payload, document) {
		this.loaderService.setValue(true)
		try {
			const res: any = await this.sharedService
				.getAttachementService(payload)
				.toPromise();
			this.loaderService.setValue(false)
			if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
				//  this.model = res.data
				if (res.data) {
					const extension = res.data.path.toLowerCase().split('.').pop()
					CommonHelper.openBase64InNewTab(res.data.content, extension)
				}
			} else if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.NO_DATA_FOUND) {

			} else {

			}
		} catch (error) {
			this.loaderService.setValue(false)
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(
					HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG,
					'OK',
					'error-snackbar'
				);
			} else {
			}
		}
	}




}
